// Module
var code = "<h2 id=\"forms\">Forms</h2> <p>Find the forms you need to successfully manage your account.</p> ";
// Exports
export default code;